// extracted by mini-css-extract-plugin
export default {"text":"ArticlesActionsPopover_text__TRxiT"};